import { RichText } from '@marriott/mi-ui-library';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { StyledAwpRichText } from './AwpRichText.styles';
import { earnRedeemStore } from '../../modules/store/earnRedeemStore';
import { useEffect } from 'react';
import clsx from 'clsx';
import { fullbleedClass } from '../../modules/utils/constants/constants';

const { NEXT_PUBLIC_AEM_SITE } = process.env;
export type RichTextProps = {
  bodyText: string;
  faqLabel?: string;
  faqEnabled?: boolean;
  faqModelHeader: string;
  styleclass?: string;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const AwpRichText = (props: RichTextProps) => {
  const setShowFaqModal = earnRedeemStore((state: earnRedeemStore) => state.setShowFaqModal);
  const setFaqModelHeader = earnRedeemStore((state: earnRedeemStore) => state.setFaqModelHeader);

  const bodyText = props?.faqEnabled
    ? props?.bodyText?.replace('[]', `<span id="faq_link_click" class="faq-label-class" >${props?.faqLabel}</span>`)
    : props?.bodyText?.replace('[]', '');

  useEffect(() => {
    setFaqModelHeader(props?.faqModelHeader);
    const faqButton = document?.getElementById('faq_link_click');

    const handleModalFunction = (event: MouseEvent) => {
      event.preventDefault();
      setShowFaqModal(true);
    };

    faqButton?.addEventListener('click', handleModalFunction);
  }, []);

  return props?.bodyText ? (
    <StyledAwpRichText
      data-component-name="m-awp-AwpRichText"
      data-testid="awp-AwpRichText"
      className={props?.styleclass}
    >
      <div
        className={clsx('container', {
          'px-md-0': props?.styleclass?.includes(fullbleedClass),
          'p-0': !props?.styleclass?.includes(fullbleedClass),
        })}
      >
        <RichText componentId="terms-condition-message" customClass="t-font-m rich-text-link" text={bodyText} />
      </div>
    </StyledAwpRichText>
  ) : null;
};

export const AwpRichTextConfig = {
  emptyLabel: 'AwpRichText',
  isEmpty: false,
  resourceType: `${NEXT_PUBLIC_AEM_SITE}/components/content/termandcondition`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AwpRichTextEditable = (props: any) => (
  <EditableComponent config={AwpRichTextConfig} {...props}>
    <AwpRichText {...props} />
  </EditableComponent>
);
